import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Modal, Button } from 'antd';
import {
  enablePartnerModalSelector,
} from '@store/serviceIntegrations/base/selectors';
import {
  setEnablePartnerModalVisibility,
} from '@store/serviceIntegrations/base/actions';

const EnablePartnerModal = () => {
  const dispatch = useDispatch();
  const isVisible = useSelector(enablePartnerModalSelector);

  const onClose = () => {
    dispatch(setEnablePartnerModalVisibility(false));
  };

  const footerButtons = [
    (
      <Button
        key="update"
        onClick={onClose}
      >
        OK
      </Button>
    ),
  ];

  return (
    <Modal
      title="Enable Service"
      width="740px"
      open={isVisible}
      footer={footerButtons}
      onCancel={onClose}
    >
      <p>You do not have this feature enabled. Please contact Conviva customer support.</p>
    </Modal>
  );
};

export default EnablePartnerModal;
